import './App.css';
import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/header/Header';

const Home = React.lazy(() => import('./components/home/Home'));
const Projects = React.lazy(() => import('./components/pages/Projects'));
const Portfolio = React.lazy(() => import('./components/pages/Portfolio'));
const Contacts = React.lazy(() => import('./components/pages/Contacts'));

function App() {
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        return savedTheme ? savedTheme : 'night';
    });

    useEffect(() => {
        localStorage.setItem('theme', theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prevTheme => (prevTheme === 'day' ? 'night' : 'day'));
    };

    return (
        <div className={theme === 'night' ? 'dark' : ''}>
            <Router>
                <Header toggleTheme={toggleTheme} theme={theme} />
                <Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                        <Route path="/" element={<Home theme={theme} />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/portfolio" element={<Portfolio />} />
                        <Route path="/contact" element={<Contacts />} />
                    </Routes>
                </Suspense>
            </Router>
        </div>
    );
}

export default App;
